<template>
  <NuxtLayout>
    <div
      class="flex flex-col items-center justify-center min-h-[70vh] gap-6 px-4 text-center"
    >
      <div class="text-8xl font-bold text-base-content/20">
        {{ error?.statusCode }}
      </div>
      <h1 class="text-2xl font-semibold">{{ title }}</h1>
      <p class="text-base-content/60 max-w-md">{{ error?.statusMessage }}</p>
      <button class="btn btn-primary" @click="handleClear">Go Home</button>
    </div>
  </NuxtLayout>
</template>

<script setup lang="ts">
const error = useError();

const title = computed(() => {
  if (error.value?.statusCode === 403)
    return "You don't have permission to view this.";
  if (error.value?.statusCode === 404) return "Not Found";
  return "Something Went Wrong";
});

function handleClear() {
  clearError({ redirect: "/login" });
}
</script>
